import React, { useState, useEffect } from "react";
import Layout, { Container } from "../components/layout";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { apiurl } from "../config/config";
import { InfiLoader } from "../components/loader";
import BackHeader from "../components/backHeader";
import { BlackButton } from "../components/buttonContainer";
import Card from "../components/card";
import { toast } from "react-toastify";

const SegmentDetails = () => {
  const navigate = useNavigate();
  const [segment, setSegment] = useState(null);
  // const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [deleteConfirmationPopup, setDeleteConfirmationPopup] = useState("");
  const [loading, setLoading] = useState(false);
  const [deleteSegmentLoading, setDeleteSegmentLoading] = useState(false);
  const { segmentObjId } = useParams();

  console.log("segmentObjId", segmentObjId);

  // Filter customers by search input
  const filteredCustomers = segment?.customers.filter((customer) =>
    customer.customerName.toLowerCase().includes(searchInput.toLowerCase()),
  );

  const fetchSegmetDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${apiurl}/admin/v1/segment/get/${segmentObjId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (response && response.data) {
        setSegment(response.data.data); // Changed to response.data.product to match expected structure
      }
    } catch (error) {
      console.error("Error fetching product details:", error); // Updated error message for clarity
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchSegmetDetails();
  // }, [segmentObjId]);
  useEffect(() => {
    if (segmentObjId) {
      fetchSegmetDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [segmentObjId]);

  const handleDeleteConfirmationPopup = () => {
    setDeleteConfirmationPopup(!deleteConfirmationPopup);
  };

  const DeleteHandler = () => {
    setDeleteSegmentLoading(true);

    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/segment/delete/${segmentObjId}`,
      headers: {
        "Content-Type": "application/json",
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        if (response.data.success) {
          toast.success(
            response.data.message
              ? response.data.message
              : "Segment deleted successfully",
          );
          // WantToDelete(false);
          // fetchCustomerData(vendorObjId);
          handleDeleteConfirmationPopup();
          navigate("/customers/segments");
          setDeleteSegmentLoading(false);
          // setDeleteCustomerIds([]);
        } else {
          toast.error(
            response.data.message
              ? response.data.message
              : "Failed to delete Segment",
          );
        }
      })
      .catch((error) => {
        console.log(error);
        setDeleteSegmentLoading(false);
        toast.error("Failed to delete Segment, Please try again later.");
      });
  };

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        {loading ? (
          <InfiLoader maintext={"Fetching segment data.."} />
        ) : (
          <div className="w-full h-full overflow-scroll p-4">
            <div className="pb-5">
              <BackHeader
                title="Segment Details"
                backButton={true}
                link="/customers/segments"
                rightSide={
                  <div className="text-center my-5">
                    <BlackButton
                      title="Delete"
                      handleSubmit={handleDeleteConfirmationPopup}
                      backgroundColor="rgb(239 68 68)"
                    />
                  </div>
                }
              />
            </div>
            <div>
              {/* Segment Info */}
              {/* <div className="p-4 bg-gray-100 rounded-md shadow-sm mb-4">
                <h2 className="text-lg font-bold">{segment?.name}</h2>
                <p className="text-sm text-gray-600">{segment?.description}</p>
                <p className="text-sm text-gray-600">
                  <strong>Vendor:</strong> {segment?.vendorDetails.vendorName}
                </p>
                <p className="text-sm text-gray-600">
                  <strong>Criteria:</strong> {segment?.criteria.city}
                </p>
              </div> */}
              <div className="p-6 bg-white rounded-lg border mb-6">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">
                  {segment?.name || "Segment Name"}
                </h2>
                <p className="text-sm text-gray-600 mb-4">
                  {segment?.description || "No description available."}
                </p>
                <div className="text-sm text-gray-700 space-y-2">
                  <p className="flex items-center">
                    <span className="font-medium text-gray-900">Vendor:</span>
                    <span className="ml-2">
                      {segment?.vendorDetails.vendorName || "N/A"}
                    </span>
                  </p>
                  <p className="flex items-center">
                    <span className="font-medium text-gray-900">Criteria:</span>
                    <span className="ml-2">
                      {segment?.criteria.city || "N/A"}
                    </span>
                  </p>
                </div>
              </div>

              {/* Search Bar */}
              <input
                type="text"
                placeholder="Search customers..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                className="w-full mb-4 p-2 border border-gray-300 rounded-md"
              />

              {/* Customers List */}
              {/* <ul className="space-y-3">
                {filteredCustomers?.map((customer) => (
                  <li
                    key={customer.customerId}
                    className="p-4 bg-white shadow-sm rounded-md border flex items-center justify-between"
                  >
                    <div>
                      <h3 className="text-lg font-semibold">
                        {customer.customerName || "Unknown Customer"}
                      </h3>
                      <p className="text-sm text-gray-500">
                        Email: {customer.customerEmail || "N/A"}
                      </p>
                      <p className="text-sm text-gray-500">
                        Phone: {customer.customerPhone || "N/A"}
                      </p>
                    </div>
                  </li>
                ))}
              </ul> */}
              <div className="relative overflow-y-auto h-full sm:rounded-lg">
                <table className="w-full text-sm text-left text-gray-500">
                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0">
                    <tr>
                      <th scope="col" className="pl-4 sm:pl-6 py-3">
                        S. No.
                      </th>
                      <th scope="col" className="pl-4 sm:pl-6 py-3">
                        Customer Name
                      </th>
                      <th scope="col" className="pl-4 sm:pl-6 py-3">
                        Email
                      </th>
                      <th scope="col" className="pl-4 sm:pl-6 py-3">
                        Phone
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredCustomers?.map((customer, index) => (
                      <tr
                        key={customer.customerId}
                        className={`${
                          index % 2 === 0 ? "bg-white" : "bg-gray-50"
                        } border-b cursor-pointer h-10`}
                      >
                        <th
                          scope="row"
                          className="pl-4 sm:pl-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                        >
                          {index + 1}
                        </th>
                        <td className="pl-4 sm:pl-6 py-4">
                          {customer.customerName || "Unknown Customer"}
                        </td>
                        <td className="pl-4 sm:pl-6 py-4">
                          {customer.customerEmail || "N/A"}
                        </td>
                        <td className="pl-4 sm:pl-6 py-4">
                          {customer.customerPhone || "N/A"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {deleteConfirmationPopup && (
              <Card.Confirmation
                message="Are you sure you want to delete this segment?"
                onConfirm={() => DeleteHandler()}
                onClose={handleDeleteConfirmationPopup}
                loading={deleteSegmentLoading}
                loadingTitle="Deleting..."
              />
            )}
          </div>
        )}
      </Container>
    </Layout>
  );
};

export default SegmentDetails;
